<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            进场公开招租申请
          </div>
        </a-space>
        <a-button
          type="primary"
          icon="plus"
          style="float: right; margin-left: 10px"
          >新建项目</a-button
        >
        <a-button type="default" icon="copy" style="float: right"
          >复制项目</a-button
        >
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="项目状态">
            <a-select default-value="全部" style="width: 160px">
              <a-select-option value="all">全部</a-select-option>
              <a-select-option value="published">已披露</a-select-option>
              <a-select-option value="draft">草稿</a-select-option>
              <a-select-option value="closed">已终止</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search placeholder="请输入项目名称" style="width: 250px" />
          </a-form-item>

          <a-button
            type="primary"
            style="margin-top: 4px"
            >查询</a-button
          >
          <a-button style="margin-left: 10px">重置</a-button>
        </a-form>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1200 }"
      >
        <template slot="operation">
          <a style="color: #1890ff">重新披露</a>
          <a-divider type="vertical" />
          <a style="color: #1890ff" @click="changeToDetail(1)">查看</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columns: [
        { title: "序号", dataIndex: "index", width: 80, key: "index" },
        { title: "项目名称", dataIndex: "name", width: 250, key: "name" },
        { title: "项目编号", dataIndex: "code", width: 180, key: "code" },
        {
          title: "计租数量(租赁面积)",
          dataIndex: "area",
          width: 200,
          key: "area",
        },
        { title: "项目状态", dataIndex: "status", width: 100, key: "status" },
        {
          title: "提交时间",
          dataIndex: "submitTime",
          width: 180,
          key: "submitTime",
        },
        {
          title: "项目负责人",
          dataIndex: "principal",
          width: 120,
          key: "principal",
        },
        {
          title: "披露开始时间",
          dataIndex: "startTime",
          width: 150,
          key: "startTime",
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 180,
          scopedSlots: { customRender: "operation" },
        },
      ],
      data: [
        {
          id: "1",
          index: 1,
          name: "上海市金山区漕泾中一东路51-81号",
          code: "L32025SH1000619",
          area: "3194.39(平方米)",
          status: "已披露",
          submitTime: "2025-06-16 09:57:05",
          principal: "曹觉",
          startTime: "2025-06-19",
        },
        {
          id: "2",
          index: 2,
          name: "上海市金山区漕泾运石路12-104号",
          code: "L32025SH1000620",
          area: "1908.69(平方米)",
          status: "已披露",
          submitTime: "2025-06-16 09:56:19",
          principal: "测试",
          startTime: "2025-06-19",
        },
        {
          id: "3",
          index: 3,
          name: "上海市金山区亭林镇李伟公路2115号",
          code: "L32025SH1000582",
          area: "1441.69(平方米)",
          status: "已披露",
          submitTime: "2025-06-03 08:49:56",
          principal: "测试",
          startTime: "2025-06-10",
        },
        {
          id: "4",
          index: 4,
          name: "上海市金山区亭林镇南亭公路5858号",
          code: "L32025SH1000523",
          area: "1080(平方米)",
          status: "已披露",
          submitTime: "2025-05-21 10:39:39",
          principal: "测试",
          startTime: "2025-05-26",
        },
      ],
    };
  },
  methods: {
    changeToDetail(val) {
      this.$emit("changeToDetail", {
        test: val,
      });
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>